import { render, staticRenderFns } from "./SupplementaryDocuments.vue?vue&type=template&id=62a4cfdc&scoped=true"
import script from "./SupplementaryDocuments.vue?vue&type=script&lang=js"
export * from "./SupplementaryDocuments.vue?vue&type=script&lang=js"
import style0 from "./SupplementaryDocuments.vue?vue&type=style&index=0&id=62a4cfdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a4cfdc",
  null
  
)

export default component.exports